import UIComponent from "../component";
import { Modal as BsModal } from 'bootstrap'

let currentModal;

export class Modal extends UIComponent {
    init() {
        this.bsModal = new BsModal(this.element);
        this.find('.btn-close')?.addEventListener('click', () => { this.onCloseBtnClick() });

        if (window.location.hash === '#' + this.attr("id")) {
            this.show();
        }
    }

    onCloseBtnClick() {
    }

    show(relatedTarget) {
        if (currentModal) {
            currentModal.hide();
        }
        this.bsModal.show(relatedTarget);
        currentModal = this;
        return this;
    }

    hide() {
        this.bsModal.hide();
        if (currentModal == this) {
            currentModal = null;
        }
        return this;
    }

    isShown() {
        return currentModal === this;
    }
}

export function isAnyModalOpen () {
    return !!currentModal;
}

export function getCurrentModal() {
    return currentModal;
}
